import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Button,
  Input,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'

// NaranciaListItem
const NaranciaListItem = (props) => {

  let [nicknameEditting, setNicknameEditting] = useState(false)
  let [nickname, setNickname] = useState('')

  // componentDidMount
  useEffect(() => {

    if (props.item && props.item.nickname) {
      setNickname(props.item.nickname)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // toggle nickname edit mode
  let _toggleEditNickname = () => {

    if (nicknameEditting === true) {
      setNicknameEditting(false)
    } else {
      setNicknameEditting(true)
    }
  }

  // save nickname
  let _saveNickname = () => {

    // change edit mode
    _toggleEditNickname()

    // if nickname is null, then return
    if (!nickname) {
      return
    }

    // save it
    props.saveNickname({
      narancia_id: props.item._id,
      nickname: nickname,
    })
  }

  return (
    <ListGroupItem style={{
      backgroundColor: '#F5F9FC',
    }}>

      <Row>
        <Col md="3" xs="12">
          {props.item.createdAt}
        </Col>
        <Col md="6" xs="12" style={{
          wordBreak: 'break-all',
        }}>
          {nicknameEditting === true ? (
            <>
            <Input
              type="text"
              style={{
                width: '80%',
                float: 'left',
              }}
              name='text'
              onChange={(e) => setNickname(e.target.value)}
              value={nickname} />

              {/* toggle button */}
              <span style={{
                float: 'right',
                marginRight: 4,
              }}>
                <FontAwesomeIcon
                  onClick={_saveNickname}
                  icon="save"
                  style={{
                  cursor: 'pointer',
                  marginRight: 10,
                }}/>
              </span>
            </>
          ) : (
            <>
              {nickname ? (
                <span style={{
                  overflowWrap: 'break-word',
                }}>
                  {nickname}
                </span>
              ) : (
                <span style={{
                  overflowWrap: 'break-word',
                }}>
                  {props.item._id}
                </span>
              )}


              {/* toggle button */}
              <span style={{
                float: 'right',
              }}>
                <FontAwesomeIcon
                  onClick={_toggleEditNickname}
                  icon="edit"
                  style={{
                  cursor: 'pointer',
                  marginRight: 10,
                }}/>
              </span>
            </>
          )}

        </Col>
        <Col md="3" xs="12">

          <FontAwesomeIcon
            icon="check"
            style={{
              color: props.item.checked === true ? 'green' : '#cccccc',
              marginRight: 10,
          }}/>

          <Link to={"/narancia_annotation?_id="+props.item._id} style={{
            color: '#000000',
            textDecoration: 'none',
          }}>
            <span>
              GO
            </span>
          </Link>


        </Col>
      </Row>

    </ListGroupItem>
  )
}

export default NaranciaListItem
